import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import {
	faHeading,
	faFont,
	faVideo,
	faFile,
	faCode,
	faFileArchive,
	faLink,
	faCopy,
	faEdit,
	faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'

import './style.css'

/*eslint-disable */
const getType = (type) => {
	switch (type) {
		case 0:
			return 'subtitle'
		case 1:
			return 'text'
		case 2:
			return 'video'
		case 4:
			return 'file'
		case 5:
			return 'html'
		case 8:
			return 'scorm'
		case 9:
			return 'lti'
		case 10:
			return 'add-quiz'
	}
}

const getIconType = (type) => {
	switch (type) {
		case 0:
			return faHeading
		case 1:
			return faFont
		case 2:
			return faVideo
		case 4:
			return faFile
		case 5:
			return faCode
		case 8:
			return faFileArchive
		case 9:
			return faLink
	}
}

export default (props) => {
	const copyScormUrl = () => {
		const urlclipboard = `${window.origin}/course/${props.courseId}/${getType(
			props.type
		)}/${content.id}`

		return navigator.clipboard
			.writeText(urlclipboard)
			.then(() => {
				// toast.info(
				// 	`The scorm url:  "${urlclipboard} " was copied successfully`,
				// 	{
				// 		position: toast.POSITION.BOTTOM_RIGHT,
				// 		className: 'toast-message',
				// 		autoClose: 3000,
				// 	}
				// )
				toast.info(
					// `The scorm url:  "${urlclipboard} " was copied successfully`,
					<div>
						The scorm url: <br /> "{urlclipboard}" was copied successfully
					</div>,
					{
						position: toast.POSITION.BOTTOM_RIGHT,
						className: 'toast-message',
						autoClose: 3000,
					}
				)
			})
			.catch(() => {
				toast.error('Failed to copy url, please try again', {
					position: toast.POSITION.BOTTOM_RIGHT,
					className: 'toast-message',
					autoClose: 3000,
				})
			})
	}

	const content = props.courseContent.find((item) =>
		item.id === props.id ? item : null
	)
	let language = props.language || {}
	return (
		<div className='tl-item sortable-item-content'>
			<div className='d-flex align-items-center pl-1 '>
				<span className='tl-item-number text-default'>{props.position}</span>
				<FontAwesomeIcon
					icon={getIconType(props.type)}
					className='tl-item-icon mr-3 text-default'
				/>
				<span className='tl-text-content text-default'>
					{content.title ? (
						content.title
					) : (
						<span className='no-title-info'>
							{language.courses ? language.courses.no_title : null}
						</span>
					)}
				</span>
			</div>
			{/* {props.courseId === content.course_id ?  */}
			<span className='tl-item-options'>
				{getType(props.type) == 'scorm' ? (
					<a
						style={{ cursor: 'pointer' }}
						onClick={copyScormUrl}
						title={`Copy scorm url: ${window.origin}/course/${
							props.courseId
						}/${getType(props.type)}/${content.id}`}
					>
						<FontAwesomeIcon icon={faCopy} className='tl-item-icon' />
					</a>
				) : null}

				<button
					title={language?.courses?.delete_container}
					className='tl-item-btn tl-item-delete'
					onClick={() => props.deleteContent(content.id, props.language_id)}
				>
					<FontAwesomeIcon icon={faTrashAlt} className='tl-item-icon' />
				</button>

				{props.type == 10 ? (
					<span
						// style={{ display: 'flex' }}
						onClick={() => props.setContentQuizEditing(content)}
					>
						<Link
							to={`/course/${props.courseId}/edit/${getType(props.type)}/${
								content.id
							}`}
							title={language.courses ? language.courses.edit_container : null}
							className='tl-item-btn tl-item-edit'
						>
							<FontAwesomeIcon icon={faEdit} className='tl-item-icon' />
						</Link>
					</span>
				) : (
					<Link
						to={`/course/${props.courseId}/edit/${getType(props.type)}/${
							content.id
						}`}
						title={language.courses ? language.courses.edit_container : null}
						className='tl-item-btn tl-item-edit'
					>
						<FontAwesomeIcon icon={faEdit} className='tl-item-icon' />
					</Link>
				)}
				{/* <Link
					to={`/course/${props.courseId}/edit/${getType(props.type)}/${
						content.id
					}`}
					title={language?.courses?.edit_container}
					className='tl-item-btn tl-item-edit'
				>
					<FontAwesomeIcon icon={faEdit} className='tl-item-icon' />
				</Link> */}
			</span>
			{/* : null } */}
		</div>
	)
}
